module.exports = __webpack_public_path__ + "static/media/Team 34 - Cuppa Grounds.b63e9f56.png";